import cn from "classnames";
import store from "./store";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { HSplitFirst } from "./components/hsplits";
import removeHash from "./services/remove-hash";
import Auth from "./services/auth";
import { hasAuth, getHomeData } from "./services/api";
import { resetMetadata } from "./actions/metas";
import { loadHomeData } from "./actions/entries";
import cabinetDoorBottom from "../images/filing-cabinet/Open.webp";
import signUp from "../images/filing-cabinet/NYA_Button_Outtake.png";
import Drawer from "../images/filing-cabinet/cabinet_drawer.png";
import CabinetSwitcherPopup from "./components/CabinetSwitcherPopup";

const ignore = (e) => {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  return false;
};

export default class OuttakesDrawerFront extends Component {
  constructor(props) {
    super(props);
    this.hideAuth0 = this.hideAuth0.bind(this);
    this.state = {
      dataLoaded: false,
      showCabinetSwitcher: false,
    };
  }
  componentDidMount() {
    this.hideAuth0();
    getHomeData().then((homeData) => {
      loadHomeData(homeData);
      this.setState({
        dataLoaded: true,
      });
    });
    resetMetadata();
  }
  UNSAFE_componentWillUpdate() {
    this.hideAuth0();
  }
  hideAuth0() {
    if (!hasAuth()) {
      Auth.hide();
    }
  }
  render() {
    let { hideLinks } = this.props;
    let showLinks = !hideLinks;
    let releaseVersion = process.env.RELEASE_VERSION;

    let style = { width: "100%", height: "100%" };
    let barStyle = { width: "100%", height: "100%" };

    let c = String.fromCharCode(169); //copyright symbol
    const orastreamLink =
      process.env.ORASTREAMLINK || "https://store.neilyoungarchives.com";
    const { showCabinetSwitcher } = this.state;
    return (
      <HSplitFirst height="109px" style={style}>
        <div style={barStyle}></div>
        <div id="drawer-front-container" className="outtakes-cabinet">
          <div id="drawer-front">
            <div className="front-wrapper">
              <div
                className="cabinet-switcher-trigger"
                onClick={() => this.setState({ showCabinetSwitcher: true })}
                aria-label="Switch Cabinet"
              >
                <img
                  className="cabinet-switcher-trigger-img"
                  src={Drawer}
                  loading="lazy"
                  alt="Switch Cabinet"
                />
              </div>
              <CabinetSwitcherPopup
                isOpen={showCabinetSwitcher}
                onClose={() => this.setState({ showCabinetSwitcher: false })}
              />
              <div className="subscribe-btn">
                <Link to="/outtakes?position=0">
                  <img src={signUp} loading="lazy" />
                </Link>
              </div>
              <Link to="/outtakes?position=0">
                <img
                  className="front outtakes-front"
                  src={cabinetDoorBottom}
                  loading="lazy"
                />
              </Link>
              <div className="outtakes-info-text">
                <p className="outtakes-info-question">WHAT IS AN OUTTAKE?</p>
                <p className="outtakes-info-body">OUTTAKES ARE RECORDINGS THAT WERE CONSIDERED FOR A PROJECT, THEN REJECTED FOR ONE OF MANY REASONS. SONGS RECORDED DURING THE TIME OF THE ALBUM CREATION ARE NOT OUTTAKES UNLESS THEY WERE ACTUALLY INCLUDED IN THE ALBUM PLAN, AND THEN LATER REJECTED.</p>
              </div>
              <div className="ul panel" />
              <div className="ur panel" />
              <div className="ll panel" />
              <div className="lm panel" />
              <div className="lr panel" />
            </div>
          </div>
          <div className="drawer-top-line" />
        </div>
      </HSplitFirst>
    );
  }
}
